export default __webpack_public_path__ + "static/media/icon-individual-active.77ce80d0.svg";